'use client';
import { cn } from '@bazaar-marketplace/utils';
import { Root, Indicator } from '@radix-ui/react-progress';
import type { FC } from 'react';

import type { ProgressProps } from './types';
import { progressVariants, progressIndicatorVariants } from './variants';

const Progress: FC<ProgressProps> = ({ className, value, variant, ...props }) => (
  <Root className={cn(progressVariants({ variant }), className)} data-slot="progress" {...props}>
    {value && value > 0 ? (
      <Indicator
        className={cn(progressIndicatorVariants({ variant }))}
        data-slot="progress-indicator"
        style={{ transform: `translateX(-${100 - (value || 0)}%)` }}
      />
    ) : null}
  </Root>
);

export { Progress };
